import { Union } from 'ts-toolbelt';

export const inchesToFeet = (inches: number): { feet: number; inches: number } => ({
  feet: Math.floor(inches / 12),
  inches: inches % 12,
});

export const feetToInches = (feet: number, inches: number): number => feet * 12 + inches;

export const getBMI = ({
  weight,
  height,
}: {
  weight: Union.Nullable<number>;
  height: Union.Nullable<number>;
}) => (weight && height ? (weight / Math.pow(height, 2)) * 703 : 0);
